/**
 * Pattern that validates an Incoming Webhook URL for Microsoft Teams.
 *
 * @see https://stackoverflow.com/questions/69169358/microsoft-teams-channel-webhook-url-format-validation-any-consistent-pattern-d#answers-header
 */
// TODO: Unit test this.
export const teamsWebhookPattern =
  '^https://[^/]+\\.webhook\\.office\\.com/.+/IncomingWebhook/.+/.+$';
